export const getUserName = (id: any, allUsers: any) => {
  return allUsers.find((val: any) => val?._id === id)?.name || "";
};

export const getMachineName = (id: any, allUsers: any) => {
  return allUsers.find((val: any) => val?._id === id)?.number || "";
};

export const currentShift = () => {
  const hour = new Date().getHours();
  if (hour > 9 && hour < 21) {
    return "Day";
  } else {
    return "Night";
  }
};

export const getProperRole = (role: any) => {
  if (role === "Sub-Contractor") return "sub-contractor";
  if (role === "P & M") return "p&m";
  if (role === "Planning Manager") return "planning-manager";
  if (role === "Account Manager") return "account-manager";
  if (role === "Project-Manager") return "project-manager";
  if (role === "Inventory-Manager") return "inventory-manager";
  if (role === "Staff") return "staff";
  if (role === "Operator") return "operator";
  if (role === "Engineer") return "engineer";
  return "";
};

export const maxValuesForBarChart = (val: any) => {
  let data: any;
  if (val > 0 && val < 999) data = 1000;
  if (val > 999 && val < 1999) data = 2000;
  if (val > 1999 && val < 4999) data = 5000;
  if (val > 4999 && val < 9999) data = 10000;
  if (val > 9999 && val < 19999) data = 20000;
  if (val > 19999 && val < 49999) data = 50000;
  if (val > 49999 && val < 99999) data = 100000;
  return data;
};
